// import api from "../../api";

const state = {
  clientData: {}
};

const getters = {};

const mutations = {
  addToClient(state, data) {
    state.clientData = data;
  },
  updateClient(state, data) {
    state.clientData = { ...state.clientData, ...data };
  }
};

const actions = {};

export const client = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
